import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getProfile } from '../api/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(() => localStorage.getItem('jwt'));
  const [user, setUser] = useState(null);
  const isAuthenticated = Boolean(token);

  const setToken = useCallback((newToken) => {
    if (newToken) {
      localStorage.setItem('jwt', newToken);
    } else {
      localStorage.removeItem('jwt');
    }
    setTokenState(newToken || null);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
  }, [setToken]);

  const refreshProfile = useCallback(async () => {
    if (!token) { setUser(null); return null; }
    try {
      const data = await getProfile(token);
      setUser(data);
      return data;
    } catch (e) {
      logout();
      return null;
    }
  }, [token, logout]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!token) { setUser(null); return; }
      const data = await refreshProfile();
      if (!mounted && data) {
        // no-op; keep for symmetry
      }
    })();
    return () => { mounted = false; };
  }, [token, refreshProfile]);

  const value = { token, user, isAuthenticated, setToken, logout, refreshProfile };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
